import SearchBar from '@/components/company/filters/SearchBar';
import FilterSelect from '@/components/company/filters/FilterSelect';
import ClearFilterButton from '@/components/company/filters/ClearFilterButton';
import type { IJobDescription } from '@/states/job.state';
import { useMemo } from 'react';

interface Props {
  jobDescriptions: IJobDescription[];
  searchTerm: string;
  selectedRole: string;
  selectedActivity: string;
  onSearch: (v: string) => void;
  onRoleChange: (v: string) => void;
  onActivityChange: (v: string) => void;
  onClear: () => void;
}

export default function ReportFilters({
  jobDescriptions,
  searchTerm,
  selectedRole,
  selectedActivity,
  onSearch,
  onRoleChange,
  onActivityChange,
  onClear,
}: Props) {
  const roleOptions = useMemo(
    () =>
      Array.from(
        new Map(jobDescriptions.map(jd => [jd.org_chart_node_id, jd.org_chart_node?.name ?? '-'])).entries()
      ).map(([id, name]) => ({ label: name, value: String(id) })),
    [jobDescriptions]
  );

  const activityOptions = useMemo(
    () =>
      Array.from(
        new Map(jobDescriptions.map(jd => [jd.org_key_activity_id, jd.org_key_activity?.name ?? '-'])).entries()
      ).map(([id, name]) => ({ label: name, value: String(id) })),
    [jobDescriptions]
  );

  return (
    <div className="flex justify-start mt-5 px-5 gap-2 w-full">
      <SearchBar value={searchTerm} onChange={onSearch} placeholder="Search reports..." className="w-72" />
      <FilterSelect label="Role" options={roleOptions} value={selectedRole} onChange={onRoleChange} />
      <FilterSelect label="Key Activities" options={activityOptions} value={selectedActivity} onChange={onActivityChange} />
      <ClearFilterButton onClear={onClear} />
    </div>
  );
}
